import { Fade, Grid, Pagination } from "@mui/material"
import { useContext, useEffect, useMemo } from "react"
import { SurveyRecord } from "../../generated/graphql"
import { useGtXs } from "../../hooks/useGtXs"
import Config from "../../services/config"
import Datagrid from "../Datagrid/Datagrid"
import { DataViewContext } from "../DataViewProvider/DataViewProvider"
import Empty from "../Empty/Empty"
import Show from "../Show/Show"
import SurveyRecordCard from "../SurveyRecordCard/SurveyRecordCard"
import getSurveyRecordColumns from "./Helpers/getSurveyRecordColumns"
import styles from './SurveyRecordsList.module.scss'

const SurveyRecordsList = () => {
    const context = useContext(DataViewContext)
    const nodes = context?.data?.surveyRecords?.nodes
    const rows = nodes || []
    const columns = useMemo(() => getSurveyRecordColumns, [])
    const gtXs = useGtXs()

    useEffect(() => {
        context.setView("surveyRecordsView")
        context.setColumnDefs(columns)
    }, [])

    const totalPages = Math.ceil((context?.totalCount || 0) / context?.paginationModel?.pageSize)
    const currentPage = (context?.paginationModel?.page || 0) + 1

    const handlePageChange = (_: any, value: number) => {
        context?.setPaginationModel({
            ...context.paginationModel,
            page: value - 1
        })

        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <Fade in={!context.loading} timeout={Config.DEFAULT_FADE_TIMEOUT}>
            <div className={styles.SurveyRecordsList}>
                {!gtXs ? (
                    <Grid container direction="column" gap={3} className={styles.MobileView}>

                        <Show on={rows?.length === 0}>
                            <Empty message="Registos não encontrados" />
                        </Show>

                        {rows.map((record: SurveyRecord) => (
                            <SurveyRecordCard key={record.id} record={record} />
                        ))}

                        <Show on={totalPages > 1}>
                            <Grid container justifyContent="center" className={styles.Pagination}>
                                <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    color="primary"
                                    size="medium"
                                    showFirstButton
                                    showLastButton
                                    siblingCount={0}
                                    boundaryCount={0}
                                />
                            </Grid>
                        </Show>
                    </Grid>
                ) : (

                    <Datagrid
                        rows={rows}
                        columns={context?.columns}
                        loading={context.loading}
                        totalCount={context?.totalCount}
                        paginationModel={context?.paginationModel}
                        setPaginationModel={context?.setPaginationModel}
                        setSortModel={context?.setSortModel}
                        setColumnOrderModel={context?.setColumnOrderModel}
                        columnVisibilityModel={context?.columnVisibilityModel}
                        setColumnVisibilityModel={context?.setColumnVisibilityModel}
                    />
                )}
            </div>
        </Fade>
    )
}

export default SurveyRecordsList
